<template>
	<div class="class-page assignment-bin-page">
		<!-- Header -->
		<ClassPageHeader :details="details"
										 :current-section="parseInt(sectionId)"
										 :course="course"
										 :menu="menu"
										 :is-class-item-page="true"
										 :course-content="courseContent"/>

		<div class="assignment-bin">
			<!-- Return back button -->
			<div class="back-link">
				<a style="cursor:pointer" @click="$router.go(-1)">
					<i class="fas fa-caret-left" aria-hidden="true"></i>{{ $t('MAIN_CONTENT.commonContent.goBack') }}
				</a>
			</div>
			<template v-if="dataBin.length > 0">
				<div class="display-table" v-for="(assignment, assignmentIndex) in dataBin"
						 :key="`displayTable_${assignment.ASSIGNMENT_CODE}_index_${assignmentIndex}`">
					<div class="display-container">

						<!-- Assignment header -->
						<div class="header color-status">
							<div :class="`pill float-left ${ dueSoon( assignment.ASSIGNMENT_END_DATE ) }`">
								{{ $t('MAIN_CONTENT.AssignmentBin.due', { date: dateFormat( assignment.ASSIGNMENT_END_DATE ) } ) }}
							</div>
							<div class="score-pill float-right">
								{{ $t('MAIN_CONTENT.commonContent.score') }} 
								<strong v-if="!!assignment.DETAILS.MAX_POINTS">
									{{ $t( 'MAIN_CONTENT.AssignmentBin.gradeOverPoints', { grade: assignment.DETAILS.GRADE_CODE, points: assignment.DETAILS.MAX_POINTS } ) }}
								</strong>
								<strong v-else>{{ $t( 'MAIN_CONTENT.AssignmentBin.hyphen' ) }}</strong>
							</div>
						</div>

						<!-- Assignment sub-header -->
						<div class="sub-header">
							<div>
								<a style="cursor:pointer" @click="goToSubmissions(assignment)">
									<h2>{{ assignment.ASSIGNMENT_NAME }}</h2>
								</a>
								<div class="float-right">
									<a style="cursor:pointer" @click="goToSubmissions(assignment)">
										{{ $t('MAIN_CONTENT.AssignmentBin.mySubmissions') }} 
										<span class="pill pill-submissions">
											{{ assignment.SUBMISSIONS.length }}
										</span>
									</a>
								</div>
							</div>
						</div>

						<!-- Attachments -->
						<div class="attached">
							<h3>
								{{ $t('MAIN_CONTENT.AssignmentBin.attachedFiles') }} 
								<span class="pill pill-attached">
									{{ assignment.ATTACHMENTS.length }}
								</span>
							</h3>
							<div v-for="(attached, attachedIndex) in assignment.ATTACHMENTS"
									 :key="`attachments_${attached.REPORT_ID}_assignment_${assignmentIndex}_index_${attachedIndex}`"
									 class="attached-file">
								<a :href="attached.ATTACHMENT_URL" target="_blank">
									<i :class="`fas ${ fileType( attached.CONTENT_ID ) }`" aria-hidden="true"></i>
									{{ attached.CONTENT_FILENAME }}
									<aria-new-tab-message :message="$t( 'MAIN_CONTENT.Accessibility.opensInNewTab' )" />
								</a>
							</div>
						</div>

						<!-- Button -->
						<div class="feedback" v-if="!!assignment.FEEDBACK.FEEDBACK_TEXT">
							<a style="cursor:pointer" @click="goToFeedback(assignment)" class="btn btn-feedback">
								{{ $t('MAIN_CONTENT.AssignmentBin.seeFeedback') }}
							</a>
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="alert alert-info">
					{{ $t('MAIN_CONTENT.AssignmentBin.noAssignmentsInAssignmentBin') }}
				</div>
			</template>
		</div>
	</div>
</template>

<script>
	import moment from "moment";
	import { mapActions, mapState, mapGetters } from "vuex";

	import ClassPageHeader from "../Header.vue";
	import ClassPageFooter from "../Footer.vue";

	import ClassPageHomeResource from '../../../api/ClassPageHome';
	import ClassPageDetailsResource from '../../../api/ClassPageDetails';
	import ClassPageAssignmentBinResource from '../../../api/ClassPageAssignmentBin';
	import ClassPageMenuResource from '../../../api/ClassPageMenu';
	import CoursesResource from '../../../api/Courses';

	export default {
		name: "AssignmentBin",
		data() {
			return {
				dataBin: [],
				menu: [],
				details: {},
				course: {},
				courseContent: {},
			};
		},
		components: {
			ClassPageHeader,
			ClassPageFooter
		},
		computed: {
			...mapGetters( [ "selectedStudent" ] ),
			sectionId() {
				return this.$route.params.folderId ? this.$route.params.folderId : 0;
			},
			assignmentBinType() {
				let type = '';
				if( this.$route.name === 'ClassPageAssignmentBin' ) {
					type = 'course';
				} else if( this.$route.name === 'ClassPageSectionAssignmentBin' ) {
					type = 'course';
				} else if ( this.$route.name === 'ClassPageGroupAssignmentBin' ) {
					type = 'group';
				} else if ( this.$route.name === 'ClassPageStudentAssignmentBin' ) {
					type = 'student';
				}

				return type;
			},
			assignmentBinSubmissionRouteName() {
				let type = '';
				if( this.$route.name === 'ClassPageAssignmentBin' ) {
					type = 'ClassPageAssignmentBinSubmission';
				} else if( this.$route.name === 'ClassPageSectionAssignmentBin' ) {
					type = 'ClassPageSectionAssignmentBinSubmission';
				} else if ( this.$route.name === 'ClassPageGroupAssignmentBin' ) {
					type = 'ClassPageGroupAssignmentBinSubmission';
				} else if ( this.$route.name === 'ClassPageStudentAssignmentBin' ) {
					type = 'ClassPageStudentAssignmentBinSubmission';
				}

				return type;
			},
			assignmentBinFeedbackRouteName() {
				let type = '';
				if( this.$route.name === 'ClassPageAssignmentBin' ) {
					type = 'ClassPageAssignmentBinFeedback';
				} else if( this.$route.name === 'ClassPageSectionAssignmentBin' ) {
					type = 'ClassPageSectionAssignmentBinFeedback';
				} else if ( this.$route.name === 'ClassPageGroupAssignmentBin' ) {
					type = 'ClassPageGroupAssignmentBinFeedback';
				} else if ( this.$route.name === 'ClassPageStudentAssignmentBin' ) {
					type = 'ClassPageStudentAssignmentBinFeedback';
				}

				return type;
			}
		},
		methods: {
			goToSubmissions(assignment) {
				let name = '';
				let params = this.$route.params;
				params.assignmentId = assignment.DROPBOX_ASSIGNMENT_ID;
				
				this.$router.push({
					name: this.assignmentBinSubmissionRouteName,
					params: params,
				});
			},
			goToFeedback(assignment) {
				let name = '';
				let params = this.$route.params;
				params.assignmentId = assignment.DROPBOX_ASSIGNMENT_ID;
				
				this.$router.push({
					name: this.assignmentBinFeedbackRouteName, 
					params: params,
				});
			},
			fetchAssignmentBin() {
				const AssignmentBin = new ClassPageAssignmentBinResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
						assignmentBinId: this.$route.params.assignmentBinId,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
					type: this.assignmentBinType,
				});

				AssignmentBin.get().then(() => {
					this.dataBin = AssignmentBin.getResponseData();
				});
			},
			fetchMenu() {
				const ClassPageMenu = new ClassPageMenuResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				ClassPageMenu.get().then(()=>{
					this.menu = ClassPageMenu.getResponseData();
				});
			},
			fetchDetails() {
				const ClassPageDetails = new ClassPageDetailsResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				ClassPageDetails.get().then(()=>{
					this.details = ClassPageDetails.getResponseData();
				});
			},
			fetchCourse() {
				const Course = new CoursesResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				Course.get().then(()=>{
					this.course = Course.getResponseData();
				});
			},
			fetchClassHome(){
				const ClassPageHome = new ClassPageHomeResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				ClassPageHome.get().then(()=>{
					this.courseContent = ClassPageHome.getResponseData().COURSE_CONTENT;
				});
			},

			/**
			 * Format the date
			 * @param { String } date
			 * @returns { String }
			 */
			dateFormat( date ) {
				if( date === '' ){
					return '';
				}

				return moment( date ).format( "MM/DD/YYYY" );
			},
			/**
			 * Due soon class name
			 * @param { String } date
			 * @returns { String }
			 */
			dueSoon( endDate ) {
				let today = moment();
				let end = moment( endDate );
				let future = moment().add( 3, "days" );
				
				if( end < today ) {
					return "due-danger";
				} else if ( today < end && end < future ) {
					return "due-warning";
				}

				return "due-info";
			},
			/**
			 * Determines the icon to use per file
			 * @param { String } mime
			 * @returns { String }
			 */
			fileType( mime ) {
				if( mime.includes( "word" ) )
					return "fa-file-word word-file";

				else if( mime.includes( "powerpoint" ) )
					return "fa-file-powerpoint ppt-file";

				else if( mime.includes( "pdf" ) )
					return "fa-file-pdf pdf-file";
				
				return "fa-file default-file";
			},
			goToClassPage() {
				let params = this.$route.params;
				
				this.$router.push({
					name: 'ClassPageHome',
					params: {
						courseSectionGUID: this.$route.params.courseSectionGUID
					},
				});
			}
		},
		created () {
			this.fetchMenu();
			this.fetchDetails();
			this.fetchCourse();
			this.fetchClassHome();
			this.fetchAssignmentBin();
		}
	};
</script>
